import EventsList from 'modules/event-list';
import { $ } from 'utils/dom';

const $eventList = $('.event-list--event-preview');

if ($eventList) {
  new EventsList($eventList, false).init();
}
